import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getUPIPayWidgetStyles = () => {
  return StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'center'
    },
    logoContainer: {
      flexDirection: 'row',
      flex: 1,
      gap: tokens.spacing.SPACING_4,
      justifyContent: 'space-around',
      marginLeft: tokens.spacing.SPACING_13
    },
    logoStyle: {
      width: 36,
      height: 24
    }
  });
};